export const GALLERY_IMAGE_SIZE = '168px';
export const GALLERY_CONTAINER_WIDTH = '1428px';
export const GALLERY_NATIVE_CONTAINER_WIDTH = 348;
export const MAX_LIGHTBOX_IMAGE_WIDTH = 450;
export const MAX_LIGHTBOX_IMAGE_HEIGHT = 500;

export const ROLLOUT_STAY_MODERATION = 'rollout_stay_moderation';
